export enum ControlType {
  unknown = 'unknown',
  advice = 'advice',
  exportFertilizationBalanceDataFertilab = 'exportFertilizationBalanceDataFertilab',
  order = 'order',
  bbaRecalculation = 'bbaRecalculation',
}

export interface SchedulerState {
  enabled: boolean;
  type: ControlType;
}

export interface SchedulerStateResponse {
  enabled: boolean;
  type: string;
}

export const mapToEnum = (value: string): ControlType => {
  if (!value) {
    return ControlType.unknown;
  }
  const formattedValue = value.charAt(0).toLowerCase() + value.slice(1); // Convert "Advice" -> "advice"
  return Object.values(ControlType).includes(formattedValue as ControlType)
    ? (formattedValue as ControlType)
    : ControlType.unknown;
};
